import { API_ENDPOINTS } from '../constants';
import axios from './axios';

const CACHE_TELEPHONE_VALIDATION: Record<string, Promise<boolean>> = {};

/**
 * Makes an HTTP request to the TELEPHONE_VALIDATION endpoint to determine
 * if a value is a valid telephone number or not.
 */
export const validateTelephone = async (value: string): Promise<boolean> => {
  if (value in CACHE_TELEPHONE_VALIDATION) {
    return CACHE_TELEPHONE_VALIDATION[value];
  }

  CACHE_TELEPHONE_VALIDATION[value] = axios
    .get<{ isValid: boolean }>(API_ENDPOINTS.TELEPHONE_VALIDATION, {
      params: { telephone: value }
    })
    .then(({ data }) => data.isValid)
    .catch(() => false);
  return CACHE_TELEPHONE_VALIDATION[value];
};
